// extracted by mini-css-extract-plugin
module.exports = {"PriceTitle":"PriceTitle_PriceTitle__GbjL9"};